import React, {useEffect, useState} from 'react'
import { Navigate, useNavigate, Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios'
import { ApiUrl, Headers } from '../services/ApiUrl';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InfoProyecto from './InfoProyecto';
import DatosPersonales from './DatosPersonales';


const PanelUsuarioProyectos = ({user, setUser}) => {
    const[proyectoActivo, setProyectoActivo] = useState([])
    const cargarProyectos= async ()=>{
        let url = ApiUrl + 'pp2023_proyectos?select=*&linkTo=id_user&equalTo='+user.id_user
        axios.get(url, {headers:Headers})
        .then( response =>{

            setProyectoActivo(response.data.results[0])

        }).catch( error=>{

            // acá es que no hay proyectos
            // puedo mostrar los botones de cargar proyectos
            setProyectoActivo({
                id_proyecto: 0
            })

        })
        .finally(function () {
          // siempre sera executado
          
        });
    }
    useEffect (()=>{
        cargarProyectos()   
    },[]); 

    const navigate = useNavigate();
    const navegarTo = (destino) => {
        const destinourl = '/' + destino;
        navigate(destinourl);
    }

    return (
        <>
       
        {
            user.login ===false &&
            <Navigate to="/iniciarsesionproyectos" />
        }
        {
            user.login ===true &&
            <div>
            <Container style={{marginTop:'50px'}}>
                <Row>
                    <Col>  
                        <h1>Panel de proyecto</h1>
                        <p>
                            En esta sección puede seguir editando su proyecto hasta realizar la presentación.
                            Luego puede ver el progreso y la factibilidad del proyecto una vez que este se encuentre aprobado y publicado.
                        </p>
                    </Col>
                </Row>
                    <DatosPersonales user={user} />
                 
                        {proyectoActivo.id_proyecto===0 ?
                        <>
                        <Row>
                        <Col> 
                            <Card>
                                
                                <Card.Body>
                                <Card.Title>Cargar nuevo proyecto</Card.Title><hr/>
                                <br/>

                                <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/PP-presupuesto-participativo-2023LOGO-TIPO.png" 
                                    width="300px" 
                                    alt="PP 2023" /> 
                                    <br/>  
                                <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/PP-joven-2023.png" 
                                    width="200px" 
                                    alt="PP Joven" />                               
                                <br/>
                                <Button variant="primary" disabled={true} onClick={()=>navegarTo('cargarproyecto')}>Cargar proyecto</Button>
                            </Card.Body>
                            </Card>    
                        </Col>                     
                        </Row>  
                        </>
                            :
                        <>
                        
                        <Row>
                            <Col>     
                            <Card>
                                <Card.Header>Proyecto activo</Card.Header>
                                <Card.Body>
                                
                                <Card.Title>
                                {proyectoActivo.titulo_proyecto !=="" ? 
                                <h4>Título: {proyectoActivo.titulo_proyecto}</h4>
                                :
                                <h4>Título del proyecto no definido</h4>
                                }                                      
                                </Card.Title><hr/>
                                {proyectoActivo.estado ==="Borrador" && 
                                <>
                                <Button variant="warning" disabled={true} onClick={()=>navegarTo('cargarproyecto')}>Continuar editando el  proyecto</Button>
                                <hr/>
                                </>
                                }
                                
                            
                                <InfoProyecto proyectoActivo={proyectoActivo} />                        
                            </Card.Body>
                            </Card>                         
                            </Col>

                        </Row>

                        </>
                        }

                          
            </Container>                
            </div>
        }        

    </>

  )
}

export default PanelUsuarioProyectos